import { render, staticRenderFns } from "./NewsAdmin.vue?vue&type=template&id=ebcb4f34"
import script from "./NewsAdmin.js?vue&type=script&lang=js&external"
export * from "./NewsAdmin.js?vue&type=script&lang=js&external"
import style0 from "./NewsAdmin.vue?vue&type=style&index=0&id=ebcb4f34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports